// import i18n from "../../i18n";

// /* ---------------------------------------------------------
//    1) UPLOAD IMAGE (your original function – not modified)
// ---------------------------------------------------------- */
// export const photoupload = async (
//   test_image: File,
//   task_id: string | number,
//   question_id: string | number,
//   token: string | null
// ) => {
//   const formData = new FormData();
//   formData.append("test_image", test_image);
//   formData.append("task_id", String(task_id));
//   formData.append("question_id", String(question_id));

//   return await fetch(`${process.env.REACT_APP_BASE_URL}/webhook/upload-irimage`, {
//     method: "POST",
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//     body: formData,
//   }).then((res) => res.json());
// };

// /* ---------------------------------------------------------
//    2) INSIGHTS API (your function – not modified)
// ---------------------------------------------------------- */
// export const callInsightsAPI = async (image_id: string, token: string | null) => {
//   if (!token) throw new Error("Authentication token is null");
//   if (!image_id) throw new Error("Image ID is empty or undefined");

//   const url = `${process.env.REACT_APP_BASE_URL}/webhook/insights?image_id=${image_id}`;
//   console.log("Calling callInsightsAPI with URL:", url, "Token:", token);

//   try {
//     const response = await fetch(url, {
//       method: "GET",
//       headers: {
//         Authorization: `Bearer ${token}`,
//         Accept: "application/json",
//         "Accept-Language": i18n.language,
//       },
//     });

//     if (!response.ok) {
//       const errorBody = await response.text();
//       console.error("callInsightsAPI failed:", {
//         status: response.status,
//         statusText: response.statusText,
//         errorBody,
//       });
//       throw new Error(`API request failed with status ${response.status}: ${errorBody}`);
//     }

//     const data = await response.json();
//     console.log("callInsightsAPI response:", JSON.stringify(data, null, 2));
//     return data;
//   } catch (error) {
//     console.error("callInsightsAPI error:", error);
//     throw error;
//   }
// };

// /* ---------------------------------------------------------
//    3) NEW FUNCTION — IMAGE QUALITY VALIDATION
// ---------------------------------------------------------- */
// export const callImageQualityValidation = async (
//   image_id: string,
//   token: string | null
// ) => {
//   if (!token) throw new Error("Authentication token is null");
//   if (!image_id) throw new Error("Image ID is empty or undefined");

//   const url = `${process.env.REACT_APP_BASE_URL}/webhook/image-quality-validation`;

//   console.log("Calling callImageQualityValidation with image_id:", image_id);

//   const formData = new FormData();
//   formData.append("image_id", image_id);

//   try {
//     const response = await fetch(url, {
//       method: "POST",
//       headers: {
//         Authorization: `Bearer ${token}`,
//         Accept: "application/json",
//         "Accept-Language": i18n.language,
//       },
//       body: formData,
//     });

//     if (!response.ok) {
//       const errorBody = await response.text();
//       console.error("callImageQualityValidation failed:", {
//         status: response.status,
//         statusText: response.statusText,
//         errorBody,
//       });
//       throw new Error(
//         `Quality Validation failed with status ${response.status}: ${errorBody}`
//       );
//     }

//     const data = await response.json();
//     console.log(
//       "callImageQualityValidation response:",
//       JSON.stringify(data, null, 2)
//     );

//     return data;
//   } catch (error) {
//     console.error("callImageQualityValidation error:", error);
//     throw error;
//   }
// };

// /* ---------------------------------------------------------
//    4) Full Flow — Upload → Insights → Quality Validation
// ---------------------------------------------------------- */
// export const processImageFlow = async (
//   test_image: File,
//   task_id: string | number,
//   question_id: string | number,
//   token: string | null
// ) => {
//   try {
//     /* Step 1: Upload Image */
//     const uploadRes = await photoupload(test_image, task_id, question_id, token);
//     console.log("Upload Response:", uploadRes);

//     const image_id = uploadRes?.data?.image_id;
//     if (!image_id) throw new Error("Upload failed: Missing image_id");

//     /* Step 2: Insights API */
//     const insightsRes = await callInsightsAPI(image_id, token);
//     console.log("Insights API Response:", insightsRes);

//     /* Step 3: Quality Validation */
//     const validationRes = await callImageQualityValidation(image_id, token);
//     console.log("Quality Validation Response:", validationRes);

//     return {
//       upload: uploadRes,
//       insights: insightsRes,
//       validation: validationRes,
//     };
//   } catch (error) {
//     console.error("processImageFlow error:", error);
//     throw error;
//   }
// };


import i18n from "../../i18n";

/* ---------------------------------------------------------
   1) UPLOAD IMAGE (Fixed)
---------------------------------------------------------- */
export const photoupload = async (
  test_image: File,
  task_id: string | number,
  question_id: string | number,
  token: string | null
) => {
  if (!token) throw new Error("Missing authentication token");

  const formData = new FormData();
  formData.append("test_image", test_image);
  formData.append("task_id", String(task_id));
  formData.append("question_id", String(question_id));

  try {
    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/webhook/upload-irimage`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: formData,
    });

    const json = await response.json();
    console.log("photoupload response:", json);

    if (!response.ok) {
      throw new Error(json?.message || "Upload failed");
    }

    return json;
  } catch (err) {
    console.error("photoupload error:", err);
    throw err;
  }
};

/* ---------------------------------------------------------
   2) QUALITY VALIDATION (Fixed)
---------------------------------------------------------- */
// export const callImageQualityValidation = async (
//   image_id: string,
//   token: string | null
// ) => {
//   if (!token) throw new Error("Authentication token missing");
//   if (!image_id) throw new Error("image_id is required");

//   const formData = new FormData();
//   formData.append("image_id", image_id);

//   try {
//     const response = await fetch(
//       `${process.env.REACT_APP_BASE_URL}/webhook/image-quality-validation`,
//       {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           Accept: "application/json"
//         },
//         body: formData,
//       }
//     );

//     const json = await response.json();
//     console.log("Image Quality Validation:", json);

//     if (!response.ok) {
//       throw new Error(json.message || "Quality validation failed");
//     }

//     return json;
//   } catch (error) {
//     console.error("callImageQualityValidation error:", error);
//     throw error;
//   }
// };

/* ---------------------------------------------------------
   3) INSIGHTS API (Optional)
---------------------------------------------------------- */
export const callInsightsAPI = async (image_id: string, token: string | null) => {
  if (!token) throw new Error("Token missing");
  if (!image_id) throw new Error("image_id is required");

  const url = `${process.env.REACT_APP_BASE_URL}/webhook/insights?image_id=${image_id}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Accept-Language": i18n.language,
      },
    });

    const json = await response.json();
    console.log("Insights API:", json);

    if (!response.ok) {
      throw new Error(json.message || "Insights API failed");
    }

    return json;
  } catch (err) {
    console.error("callInsightsAPI error:", err);
    throw err;
  }
};

/* ---------------------------------------------------------
   4) Upload → Insights → Quality Validation (Fully Fixed)
---------------------------------------------------------- */
export const processImageFlow = async (
  test_image: File,
  task_id: string | number,
  question_id: string | number,
  token: string | null
) => {
  try {
    /* Step 1: Upload Image */
    const uploadRes = await photoupload(test_image, task_id, question_id, token);
    console.log("Upload Response:", uploadRes);

    const image_id = uploadRes?.data?.apiResponse?.image_id;
    if (!image_id) throw new Error("Upload failed: image_id not returned");

    /* Step 2: Insights API */
    const insightsRes = await callInsightsAPI(image_id, token);

    /* Step 3: Quality Validation */
    // const validationRes = await callImageQualityValidation(image_id, token);

    return {
      upload: uploadRes,
      insights: insightsRes,
      // validation: validationRes,
    };
  } catch (error) {
    console.error("processImageFlow error:", error);
    throw error;
  }
};

